<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

import config from '@/config/config';

export default {
  name: 'ComponentsHeader',
  data() {
    return {
      app : config.app,
    }
  },
  computed: {
    ...mapState(config.app, [
      'course',
    ]),
    ...mapGetters(config.app, [
      'isLoggedIn',
    ]),
    shouldShowMyCourses() {
      return this.course;
    },
  },
  methods: {
    ...mapActions(config.app, [
      'logout',
    ]),
  },
};
</script>
<template>
    <header>
        <div class="container">
            <div class="d-flex justify-content-between">
                <a href="https://zdrowiezaczynasiewglowie.pl/">
                    <img src="@/assets/logo.png" alt="logo" style="width: 140px" />
                </a>
                <div v-if="app === 'user' && isLoggedIn" class="d-flex flex-1 justify-content-center pr-5 pl-5 pt-3">
                    <router-link :to="{ name: 'courses' }" class="mr-5" v-if="shouldShowMyCourses">
                        Moje Kursy
                    </router-link>
                    <router-link :to="{ name: 'account' }" class="mr-5">
                        Moje Konta
                    </router-link>
                    <router-link :to="{ name: 'invitations' }">
                        Zaproszenia
                    </router-link>
                </div>
                <a class="login pointer" @click="logout" v-if="isLoggedIn">
                    WYLOGUJ
                </a>
            </div>
        </div>
    </header>
</template>
